import { Box, Skeleton, Stack } from '@mui/material';

/**
 * ChatHistoryLoadingState (MUI version)
 * Replaces the Tailwind/Skeleton UI with Material‑UI components.
 */
export default function ChatHistoryLoadingState() {
  return (
    <Box p={2}>
      <Stack spacing={3}>
        {/* top header placeholder */}
        <Skeleton variant="rectangular" sx={{ height: 40, width: '100%', borderRadius: 1 }} />

        {/* first group */}
        <Stack spacing={1}>
          <Skeleton variant="rectangular" sx={{ height: 16, width: 96, borderRadius: 1 }} />
          <Stack spacing={1}>
            <Skeleton variant="rectangular" sx={{ height: 56, width: '100%', borderRadius: 1 }} />
            <Skeleton variant="rectangular" sx={{ height: 56, width: '100%', borderRadius: 1 }} />
          </Stack>
        </Stack>

        {/* second group */}
        <Stack spacing={1}>
          <Skeleton variant="rectangular" sx={{ height: 16, width: 96, borderRadius: 1 }} />
          <Stack spacing={1}>
            <Skeleton variant="rectangular" sx={{ height: 56, width: '100%', borderRadius: 1 }} />
            <Skeleton variant="rectangular" sx={{ height: 56, width: '100%', borderRadius: 1 }} />
            <Skeleton variant="rectangular" sx={{ height: 56, width: '100%', borderRadius: 1 }} />
          </Stack>
        </Stack>
      </Stack>
    </Box>
  );
}
